module.exports = __webpack_public_path__ + "4a3f803ea823f0cc.svg";